import React from 'react';
import { useParams } from 'react-router-dom';
import Lock from '../components/organism/Lock';
import { hasPermission } from '../stores/accessControlStore';

interface IProtectedRoute {
  modulesAllowed?: string[];
  element: React.JSX.Element;
  moduleFromParam?: string | null;
  customLock?: React.JSX.Element;
}

const ProtectedRoute = React.memo(
  ({
    modulesAllowed,
    element,
    moduleFromParam,
    customLock,
  }: IProtectedRoute) => {
    const params = useParams();

    const module =
      moduleFromParam && params[moduleFromParam]
        ? [String(params[moduleFromParam])]
        : modulesAllowed || [];

    if (hasPermission(module) || module.includes('esquadrao-elite')) {
      return element;
    }

    if (customLock) {
      return customLock;
    }

    return <Lock />;
  }
);

ProtectedRoute.displayName = 'ProtectedRoute';

export default ProtectedRoute;
